import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

/**
 * Soft-delete a playable feedback record.
 * Call: mutate(feedbackId)
 */
export function useDeletePlayableFeedback() {
  const { privateFetch } = useContext(FetchContext);
  const qc = useQueryClient();

  return useMutation(
    (feedbackId) => privateFetch.delete(`/v1/admin/podcast/playable-feedback/${feedbackId}`),
    {
      onSettled: () => qc.invalidateQueries('admin-playable-feedback'),
    }
  );
}
